import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Formik, Form, Field } from 'formik';

import Contact, { validationSchema } from '../../../models/Contact';
import { ContactTypes } from '../../../config/constants';
import Button from '../../common/Button';
import TextInput from '../../common/form/TextInput';
import TextArea from '../../common/form/TextArea';
import FormFeedback from '../../common/form/FormFeedback';
import RadioSelect from '../../common/form/RadioSelect';

import './ContactForm.css';
import FormResult from '../../../FormResult';

class ContactForm extends Component {
  renderForm = (formProps) => {
    const {
      // values,
      // errors,
      // touched,
      // handleChange,
      // handleBlur,
      status,
      handleSubmit,
      isSubmitting,
    } = formProps;
    const { returnToItem } = this.props;

    return (
      <Form>
        <FormFeedback status={status} />

        <Field name="name" label="Name" placeholder="John Doe" component={TextInput} />

        <Field
          name="type"
          label="Type"
          options={_.map(ContactTypes, (v, k) => ({ label: v, value: k }))}
          component={RadioSelect}
        />

        <Field
          name="focus"
          label="Focus"
          placeholder="Ex: watches, cars, stamps, etc."
          component={TextInput}
        />

        <hr />

        <Field name="location" label="Location" placeholder="Morro Bay, CA" component={TextInput} />

        <div className="columns">
          <div className="column">
            <Field
              name="email"
              type="email"
              label="Email"
              className="contactForm-email"
              component={TextInput}
            />
          </div>

          <div className="column">
            <Field
              name="phoneNumber"
              type="tel"
              label="Phone Number"
              className="contactForm-phoneNumber"
              component={TextInput}
            />
          </div>
        </div>

        <hr />

        <Field name="notes" label="Notes" className="contactForm-notes" component={TextArea} />

        <div className="field is-grouped is-grouped-right">
          <div className="control">
            <Button
              type="submit"
              label={returnToItem ? 'Save Contact and Return to Item' : 'Save Contact'}
              isActive={isSubmitting}
              isDisabled={isSubmitting}
              color="primary"
              handler={handleSubmit}
              className="contactForm-submitButton"
            />
          </div>
        </div>
      </Form>
    );
  };

  render() {
    const { contact } = this.props;

    return (
      <div className="contactForm">
        <Formik
          initialValues={contact}
          onSubmit={(values, { setSubmitting, setStatus }) => {
            const onSuccess = () => {
              setSubmitting(false);
            };
            const onFailure = (status) => {
              setSubmitting(false);
              setStatus(new FormResult(status));
            };

            this.props.onSubmit(values, onSuccess, onFailure);
          }}
          validationSchema={validationSchema}
          render={this.renderForm}
        />
      </div>
    );
  }
}

ContactForm.propTypes = {
  contact: PropTypes.instanceOf(Contact).isRequired,
  returnToItem: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
};

ContactForm.defaultProps = {
  returnToItem: false,
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/pages/contacts/ContactForm.jsx